"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.round = void 0;
function round(n, decimals) {
    const h = +('1'.padEnd(decimals + 1, '0')); // 10 or 100 or 1000 or etc
    return Math.round(n * h) / h;
}
exports.round = round;
